import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { UnchangingImageRenderer } from '../customRenderers/UnchangingImageRenderer';
import { CustomImageRenderer } from '../customRenderers/imageSourceRender';
import { GALLERY_CONSTS } from 'pro-gallery-lib';
export const WixProGalleryWithCustomImageRenderer = WixProGallery => props => {
  const customComponents = {
    ...props.customComponents,
    customImageRenderer: imageRendererProps => {
      if (![GALLERY_CONSTS.viewMode.EDIT, GALLERY_CONSTS.viewMode.PREVIEW].includes(props.viewMode) // TODO - fix viewMode api and then use it to enable only in site mode
      ) {
        const isInFirstFold = props.isInFirstFold;
        let priorityLoading;
        // We want to work with fetch priority only if we have the isInFirstFold value, otherwise this value will be undefined and we dont want to use it
        // It sits under the interaction boolean because this is relevant only for the loading of the page, before the interaction. (this can change if we want to later on)
        if (!props.firstInteractionRecorded) {
          if (isInFirstFold !== undefined) {
            priorityLoading = isInFirstFold;
          }
        }
        const _imageRendererProps = {
          ...imageRendererProps,
          allowChanges: props.firstInteractionRecorded,
          priorityLoading
        };
        return /*#__PURE__*/React.createElement(UnchangingImageRenderer, _imageRendererProps);
      } else {
        return /*#__PURE__*/React.createElement(CustomImageRenderer, imageRendererProps);
      }
    }
  };
  return /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    customComponents: customComponents
  }));
};
//# sourceMappingURL=withCustomImageRenderer.js.map